module.exports = __webpack_public_path__ + "img/qrcode.4446a482.jpg";